import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import { Paginator } from 'primereact/paginator';

function CratesReport() {
    const [cratesData, setCratesData] = useState([]);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);

    console.log(cratesData);

    const getCratesData = async () => {
        try {
            const response = await axios.get('https://api.trucoo.in/crates/view/', {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            console.log(response.data);
            if (response.data.status === 'success') {
                setCratesData(response.data.data);
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
    };

    const onPageChange = (event) => {
        setFirst(event.first);
    };

    useEffect(() => {
        getCratesData();
    }, []);


    const totalCratesOut = cratesData.reduce((sum, crate) => sum + Number(crate.cratesOut), 0);
    const totalCratesIn = cratesData.reduce((sum, crate) => sum + (Number(crate.cratesIn) || 0), 0);
    const totalBalance = Number(totalCratesOut) - Number(totalCratesIn);

    return (
        <>
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                <h4 className="box-title">Crates Report</h4>
                                <p className="mb-0 box-subtitle">All Crate Transactions</p>
                            </div>
                            <div className="box-body">
                                <div className="table-responsive">
                                    <table className="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                                        <thead>
                                            <tr className="text-dark">
                                                <th>S.No</th>
                                                <th>Date</th>
                                                <th>Dealer</th>
                                                <th>Crates Out</th>
                                                <th>Crates In</th>
                                                <th>Crates Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cratesData.length > 0 ? cratesData.slice(first, first + rows).map((crate, index) => (
                                                <tr key={index}>
                                                    <td>{index + first + 1}</td>
                                                    <td>{crate.date}</td>
                                                    <td>{crate.dealerData.name} - <small>{crate.dealerData.dealer}</small></td>
                                                    <td>{crate.cratesOut}</td>
                                                    <td>{crate.cratesIn || 0}</td>
                                                    <td>{crate.cratesOut - (crate.cratesIn || 0)}</td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan={6}>No Crates Data Available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                        {/* Total Row */}
                                        {cratesData.length > 0 && (
                                            <tfoot>
                                                <tr className="text-dark bg-light">
                                                    <th colSpan="3" className="text-right">Total:</th>
                                                    <th>{totalCratesOut}</th>
                                                    <th>{totalCratesIn}</th>
                                                    <th>{totalBalance}</th>
                                                </tr>
                                            </tfoot>
                                        )}
                                    </table>
                                    {/* <Paginator className="custom-paginator" first={first} rows={rows} totalRecords={cratesData?.length} onPageChange={onPageChange} /> */}
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            <Footer />
        </>
    );
}

export default CratesReport;
